<button type="button" class="dialog-close" (click)="dialogRef.close()"> <svg-icon name="cross"></svg-icon> </button>

<div class="install-app-dialog__body">
  <p class="install-app-dialog__title" mat-dialog-title>Scan the QR code with your phone</p>
  <div class="install-app-dialog__qr">
    <img src="/assets/images/native/open-native-app-store.png" alt="QR" title="QR" />
  </div>
</div>
